import { MaskedLines, FadeUp, Overline } from "@/components/Reveal";

export default function PageHeader({ overline, lines, intro, testid }) {
  return (
    <section className="ledger-lines relative overflow-hidden pb-16 pt-36 lg:pb-20 lg:pt-44">
      <div
        className="pointer-events-none absolute inset-y-0 left-8 hidden w-px bg-gold/40 lg:block"
        aria-hidden="true"
      />
      <div className="mx-auto max-w-7xl px-6">
        <FadeUp>
          <Overline>{overline}</Overline>
        </FadeUp>
        <MaskedLines
          as="h1"
          inView
          delay={0.1}
          lines={lines}
          className="mt-6 max-w-4xl font-serif text-5xl font-medium leading-[1.05] tracking-tight text-ink sm:text-6xl lg:text-7xl"
        />
        {intro && (
          <FadeUp delay={0.35}>
            <p className="mt-8 max-w-2xl text-lg leading-relaxed text-stone2">{intro}</p>
          </FadeUp>
        )}
        <div data-testid={testid} />
      </div>
    </section>
  );
}
